import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ThinCloseIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 13 12",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fillOpacity: 0.85,
    d: "M.99 11.804a.694.694 0 0 0 .96 0l4.84-4.84 4.84 4.84a.687.687 0 0 0 .961 0 .685.685 0 0 0 0-.953l-4.84-4.847 4.84-4.84a.678.678 0 0 0 0-.953.68.68 0 0 0-.96 0L6.79 5.05 1.95.21a.673.673 0 0 0-.961 0 .685.685 0 0 0 0 .953l4.84 4.84-4.84 4.848a.678.678 0 0 0 0 .952Z"
  })
});
export default ThinCloseIcon;